export default __webpack_public_path__ + "img/f744dfa213f8c763d22e3a5be614f10c.png";